import React, { useEffect, useState } from "react";
import { useActasStore } from "../../../../../store/actasStore";
import { useActaDetalleStore } from "../../../../../store/actaDetalleStore";

const TabVideo = () => {
    const { actaDetalle } = useActaDetalleStore();
    // const { actaDetalle } = useActasStore();
    const { archivos } = actaDetalle;

    const [video, setVideo] = useState(null)
    const [key, setKey] = useState(true); 
    const gifDuration = !key ? 4000 : 1; 

    useEffect(() => {
        const timer = setInterval(() => {
            setKey(prevKey => !prevKey);
            if (key) {
                setVideo(archivos.video.file)
            } else {
                setVideo(null)
            }
        }, gifDuration);


        return () => {clearInterval(timer); };
    }, [key]);

    return (
        <>
            <div className="mx-auto pt-5">
                {/* <h4 className="text-center">Video</h4> */}
                <section className="d-flex justify-content-center align-items-start gap-3">
                    <div style={{ height: "400px", width: "700px" }} className="bg-dark">
                        <img
                            className="w-100 h-100"
                            style={{ objectFit: "contain" }}
                            src={video}
                            alt="video-infracción"
                        />
                    </div>
                </section>
            </div>
        </>
    );
}

export default TabVideo;
